import { render, staticRenderFns } from "./livingbody.vue?vue&type=template&id=3dc8049e&scoped=true&"
import script from "./livingbody.vue?vue&type=script&lang=js&"
export * from "./livingbody.vue?vue&type=script&lang=js&"
import style0 from "./livingbody.vue?vue&type=style&index=0&id=3dc8049e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc8049e",
  null
  
)

export default component.exports